/**
 * The lobby tablet's own credential (Reception R4): not a person's session.
 * A token from POST /kiosk-device/login, kept on the device, sent only to
 * /kiosk-device/* — the main API refuses it, and it refuses the main token.
 */
const KEY = 'spaciora-kiosk-device';
export const KIOSK_DEVICE_SIGNED_OUT = 'spaciora:kiosk-device-signed-out';

export interface StoredKioskDevice { token: string; deviceId: string }

export function getKioskDevice(): StoredKioskDevice | null {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed.token === 'string' && typeof parsed.deviceId === 'string' ? parsed : null;
  } catch {
    return null;
  }
}

export function setKioskDevice(device: StoredKioskDevice): void {
  localStorage.setItem(KEY, JSON.stringify(device));
}

export function clearKioskDevice(): void {
  try { localStorage.removeItem(KEY); } catch { /* nothing to clear */ }
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(KIOSK_DEVICE_SIGNED_OUT));
}

export function isKioskDevicePath(url: string | null | undefined): boolean {
  return !!url && url.replace(/^\/api/, '').startsWith('/kiosk-device/');
}

/** The queue's owner on a tablet nobody is signed in to: the device (A16's "one
 *  queue per person", with the device as the person). */
export function kioskQueueOwner(): string | null {
  const device = getKioskDevice();
  return device ? `kiosk-device:${device.deviceId}` : null;
}

/**
 * 🔴 THE TRANSITION (A10). A tablet already running on a staff login keeps
 * working on deploy, with a warning, until this date; after it the page asks
 * for a device code whoever is signed in. Staff routes are not cut: the desk
 * uses them too.
 */
export const KIOSK_STAFF_SESSION_UNTIL = '2027-02-01';

export function staffKioskAllowed(now: Date = new Date()): boolean {
  return now < new Date(`${KIOSK_STAFF_SESSION_UNTIL}T00:00:00+05:30`);
}
